<mat-card class="climatelog-card" >
  <mat-card-header>
    <div mat-card-avatar class="mclimatelog-header-image"><mat-icon aria-hidden="false" aria-label="home icon">account_circle</mat-icon></div>
    <mat-card-title> Climate Logfile   </mat-card-title>
  </mat-card-header>
  <mat-card-content>

<mat-accordion>
  <mat-expansion-panel (opened)="panelOpenState = true"
                       (closed)="panelOpenState = false"  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        Filter selection
      </mat-panel-title>
      <mat-panel-description>
        {{panelOpenState ? 'use reload to activate new filters' : 'Press to select'}}
      </mat-panel-description>
    </mat-expansion-panel-header>

    <button mat-button color="primary" (click)="onReload()"> Reload</button>
    <section class="climatelog-section">
  <span class="climatelog-list-section">
    <ul>
      <li *ngFor="let select of selections">
               <mat-checkbox class="climatelog-margin" [checked]="select.active"
                             (change)="select.active = !select.active" value=1)>  {{ select.name }}      </mat-checkbox>
      </li>
    </ul>
  </span>
    </section>
  </mat-expansion-panel>
</mat-accordion>

<hr/>

<table >
  <tr *ngFor="let log of climateLog">
    <td>{{log.DATE}}</td>
    <td>{{log.LEVEL}}</td>
    <td>{{log.CLASS}}</td>


    <td>{{log.MESSAGE}}</td>
  </tr>
</table>



  </mat-card-content>
</mat-card>
